"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
0 && (module.exports = {
    Material3Color: null,
    Material3DynamicColor: null
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get Material3Color () {
        return Material3Color;
    },
    get Material3DynamicColor () {
        return Material3DynamicColor;
    }
});
function Material3DynamicColor(name) {
    return null;
}
function Material3Color(name) {
    return null;
}

//# sourceMappingURL=materialColor.js.map
